import react, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/store';
import { Survey } from '../types';
import { deleteSurvey, fetchSurveys } from '../Firebase/utils';
import { createSurvey } from '../store/features/CreateSurveySlice';
import { SiGhostery } from "react-icons/si";
import Modal from '../Components/Modal';
import { useQuery } from '@tanstack/react-query';


const ManageSurveys = () => {

    const user = useAppSelector(state => state.user.user);
    const [ surveys, setSurveys ] = useState<Survey[]>([]);
    const [ selectedSurvey, setSelectedSurvey ] = useState<Survey | null>(null);
    const [ surveyToDelete, setSurveyToDelete ] = useState<Survey | null>(null);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { data: surveysList, isLoading: isSurveysListLoading } = useQuery({
        queryKey: ['surveys', user.uid],
        queryFn: async () => {
            const surveysList = await fetchSurveys(user);
            return surveysList;
        },
        enabled: user !== null
    });

    useEffect(() => {
      if(surveysList){
        setSurveys(surveysList)
      }
    }, [surveysList]);

    // useEffect(() => {
    //     if(user === null){
    //         navigate('/');
    //     }
    //     const getSurveys = async () => {
    //         const surveysList = await fetchSurveys(user);
    //         if(surveysList){
    //             // surveysList.docs.map((doc: any) => {
    //             //     console.log(doc.data());
    //             // });
    //             setSurveys(
    //                 surveysList.docs.map((doc: any) => {
    //                     return { ...doc.data(), id: doc.data().id } as Survey;
    //                 })
    //             );
    //         }
    //     }
    //     getSurveys();
    // }, []);

    console.log(surveys);

    const handleSelectSurvey = (survey: Survey) => {
        dispatch(createSurvey(survey));
        navigate('/survey-builder');
    }

    const handleDeleteSurvey = async () => {
        if(surveyToDelete !== null){
            deleteSurvey(user, surveyToDelete);
            surveys.splice(surveys.indexOf(surveyToDelete), 1);
            setSurveyToDelete(null);
            setSelectedSurvey(null);
        }
    }

    const handleAnalyzeResults = (survey: Survey) => {
        dispatch(createSurvey(survey));
        navigate(`/analyze-results/${survey.id}`);
    }

    return (
        <div className='flex flex-col min-h-screen'>
            <header className='flex flex-col md:flex-row justify-center items-center gap-3 md:gap-10 text-[#3da8e2] text-center p-4 pt-20'>
                <div className='flex flex-col gap-4'>
                    <h1 className='text-6xl md:text-9xl font-Velocity tracking-widest'>Manage Surveys</h1>
                </div>
            </header>
            <div className='flex flex-col items-center gap-10 mt-10'>
                {surveys.map((survey: Survey) => {
                    return(
                        <button onClick={() => setSelectedSurvey(survey)} className='w-11/12 md:w-1/2 bg-[#3da8e2] text-white p-4 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest'>
                            <h3 className='text-md md:text-2xl font-Velocity tracking-widest text-white overflow-hidden whitespace-nowrap text-ellipsis'>{survey.title}</h3>
                        </button>
                    );
                })}
            </div>
            {surveys.length === 0 && 
            <div className='flex flex-col items-center justify-center gap-24 w-full h-96 text-white'>
                    {isSurveysListLoading ? 
                      <h2 className='text-3xl text-center font-BCBold capitalize'>Loading...</h2>
                      :
                      <h2 className='text-3xl text-center font-BCBold capitalize'>You do not have any surveys</h2>
                    }
                    <button onClick={() => navigate('/survey-builder')} className='bg-[#3da8e2] text-white p-4 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest'>Create Your First Survey</button>
                    {/* <SiGhostery /> */}
            </div>}
            <Modal title={selectedSurvey?.title} openState={selectedSurvey !== null} onClose={() => {setSelectedSurvey(null)}}>
                <div className='flex gap-4'>
                    <button onClick={() => {setSurveyToDelete(selectedSurvey)}} className='w-full bg-red-500 text-white p-4 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest'>Delete</button>
                    <button onClick={() => {handleSelectSurvey(selectedSurvey as Survey)}} className='w-full bg-[#3da8e2] text-white p-4 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest'>Edit</button>
                    <button onClick={() => {handleAnalyzeResults(selectedSurvey as Survey)}} className='w-full bg-[#3da8e2] text-white p-4 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest'>Analyze Results</button>
                </div>
            </Modal>
            <Modal title={'Delete Survey'} openState={surveyToDelete !== null}  onClose={() => {setSurveyToDelete(null)}}>
                <h2 className='mt-5 mb-16 text-white text-2xl text-center font-BCBold'>Are you sure you want to delete this survey?</h2>
                <button onClick={() => {handleDeleteSurvey()}} className='bg-[#3da8e2] text-white p-4 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest'>Delete</button>
            </Modal>
        </div>
    );
}

export default ManageSurveys;